import React from 'react'
import { useTemplateContext } from '../Context'

export const RowExtension = (props) => {
  const { components } = useTemplateContext()

  return (
    <div>
      <components.TemplateDisplayValue {...props} />
    </div>
  )
}
